import { Favorite } from '~/models/document/Favorite'

export class FavoritesState {
  public favorites: Favorite[] = []
}

export default (): FavoritesState => new FavoritesState()
